import { render, staticRenderFns } from "./IeltsOverall.vue?vue&type=template&id=40344a92&scoped=true&"
import script from "./IeltsOverall.vue?vue&type=script&lang=js&"
export * from "./IeltsOverall.vue?vue&type=script&lang=js&"
import style0 from "./IeltsOverall.vue?vue&type=style&index=0&id=40344a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40344a92",
  null
  
)

export default component.exports